module.exports = __webpack_public_path__ + "media/images/icon__locked-6593059bb627fb4ad61b7ada90519f7d.png";